import React from 'react';
import { BodyText, DesignSystemTextProps, FlexDynamic } from '@minecraft.atoms';
import Icon from '@minecraft.icon';
import { Trans } from '@blocs.i18n';
import { WindowWidthContext } from '@minecraft.utils';

type PaywallBannerProps = {
  'data-testid'?: string;
  'data-qa-id'?: string;
  title: string;
  iconColor?: 'primary' | 'warningInverted' | 'danger';
  bgColor?: 'info' | 'warningInverted' | 'danger';
  iconName?: string;
  fontWeight?: DesignSystemTextProps['fontWeight'];
};

export const PaywallBanner = ({
  'data-testid': testId = 'opportunity-cost-banner',
  'data-qa-id': qaId,
  title,
  iconColor = 'primary',
  bgColor = 'info',
  iconName = 'zoom',
  fontWeight,
}: PaywallBannerProps) => {
  const isMobile = WindowWidthContext.useIsMobile();

  return (
    <FlexDynamic
      w="full"
      justifyContent="center"
      alignItems="center"
      gap="5"
      wrap="nowrap"
      mdProps={{
        gap: '3',
      }}
      bgColor={bgColor}
      className="cn_atom_p-6 cn_shadow-md"
      borderRadius="md"
      mb="6"
      mt="1"
      data-testid={testId}
      data-qa-id={qaId}
    >
      <Icon name={iconName} themeColor={iconColor} size={isMobile ? 'lg' : 'md'} />
      <BodyText align="left" fontWeight={fontWeight}>
        <Trans i18nKey={title} components={[<BodyText fontWeight="bold" as="span" />]} />
      </BodyText>
    </FlexDynamic>
  );
};
